export const UserGroup = (fill: any) => {
  return (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_228_13285)">
        <path
          d="M21.6929 13.858H19.7324C19.9323 14.4051 20.0414 14.9956 20.0414 15.611V23.0205C20.0414 23.2771 19.9968 23.5234 19.9155 23.7524H23.1567C24.3674 23.7524 25.3523 22.7674 25.3523 21.5567V17.5174C25.3524 15.4997 23.7107 13.858 21.6929 13.858Z"
          fill={fill?.fill}
        />
        <path
          d="M5.3129 15.611C5.3129 14.9955 5.42208 14.4051 5.62191 13.858H3.66142C1.64359 13.858 0.00195312 15.4997 0.00195312 17.5175V21.5568C0.00195312 22.7674 0.986904 23.7524 2.19763 23.7524H5.43881C5.35756 23.5233 5.3129 23.2771 5.3129 23.0205V15.611Z"
          fill={fill?.fill}
        />
        <path
          d="M14.9168 11.9508H10.4349C8.41702 11.9508 6.77539 13.5924 6.77539 15.6103V23.0198C6.77539 23.424 7.10306 23.7517 7.50728 23.7517H17.8444C18.2486 23.7517 18.5763 23.424 18.5763 23.0198V15.6103C18.5763 13.5924 16.9346 11.9508 14.9168 11.9508Z"
          fill={fill?.fill}
        />
        <path
          d="M12.6764 2.24786C10.2496 2.24786 8.27539 4.22212 8.27539 6.64888C8.27539 8.29492 9.18389 9.73251 10.5256 10.4873C11.162 10.8453 11.8956 11.0498 12.6764 11.0498C13.4571 11.0498 14.1907 10.8453 14.8271 10.4873C16.1689 9.73251 17.0773 8.29487 17.0773 6.64888C17.0773 4.22217 15.1031 2.24786 12.6764 2.24786Z"
          fill={fill?.fill}
        />
        <path
          d="M4.94759 6.35022C3.13271 6.35022 1.65625 7.82668 1.65625 9.64156C1.65625 11.4564 3.13271 12.9329 4.94759 12.9329C5.40796 12.9329 5.84634 12.8375 6.24457 12.6661C6.93309 12.3697 7.5008 11.845 7.85209 11.1877C8.09866 10.7264 8.23893 10.2001 8.23893 9.64156C8.23893 7.82673 6.76247 6.35022 4.94759 6.35022Z"
          fill={fill?.fill}
        />
        <path
          d="M20.4046 6.35022C18.5897 6.35022 17.1133 7.82668 17.1133 9.64156C17.1133 10.2002 17.2536 10.7264 17.5001 11.1877C17.8514 11.845 18.4191 12.3697 19.1076 12.6661C19.5059 12.8375 19.9443 12.9329 20.4046 12.9329C22.2195 12.9329 23.696 11.4564 23.696 9.64156C23.696 7.82668 22.2195 6.35022 20.4046 6.35022Z"
          fill={fill?.fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_228_13285">
          <rect width="25.3503" height="25.3503" fill="white" transform="translate(0 0.324829)" />
        </clipPath>
      </defs>
    </svg>
  );
};
